import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import modalTypes from './';


const mapStateToProps = state => ({
    ...state.modal
});

class ModalRoot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false
        };
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {

            this.setState({
                modalIsOpen: nextProps.modalProps.open
            });
        }
    }


    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    render() {
        const SpecifiedModal = modalTypes[this.props.modalType];
        const size = this.props.modalProps.size ? this.props.modalProps.size : undefined;
        return (
            <div>
                {
                    this.props.modalType || this.props.modalProps.open === true ?
                        <Modal size={size} show={this.props.modalProps.open} dialogClassName={this.props.modalProps.modalClassName != null ? this.props.modalProps.modalClassName : null} onHide={this.props.modalProps.closeModal}>
                            <SpecifiedModal
                                closeModal={this.closeModal}
                                {...this.props.modalProps}
                            />
                        </Modal> : null
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, null)(ModalRoot);
//{this.props.modalSize != null ? this.props.modalSize : null}